module.exports = __webpack_public_path__ + "img/04n.88c5e740.png";